export const numberToFixed = (number: number | undefined, decimals: number = 1): number => +(number?.toFixed(decimals) ?? 0) || 0;
